import React from "react";

export default function ChinaNewYearFrame6({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-6cn1{fill:#e0b55f}.cls-6cn2{stroke-width:3.29px}.cls-6cn10,.cls-6cn2,.cls-6cn3,.cls-6cn4,.cls-6cn5,.cls-6cn6,.cls-6cn8,.cls-6cn9{fill:none;stroke:#e0b55f;stroke-linecap:round;stroke-miterlimit:10}.cls-6cn11{fill:#be1d13}.cls-6cn3{stroke-width:2.04px}.cls-6cn4{stroke-width:1px}.cls-6cn5{stroke-width:2.6px}.cls-6cn6{stroke-width:1.08px}.cls-6cn8{stroke-width:1.36px}.cls-6cn9{stroke-width:.79px}.cls-6cn10{stroke-width:2.58px}"
            }
          </style>
        </defs>
        <rect
          width={1424.02}
          height={1424.02}
          x={287.99}
          y={287.99}
          rx={141.64}
          ry={141.64}
          style={{
            strokeWidth: "41.73px",
            fill: "none",
            stroke: "#e0b55f",
            strokeLinecap: "round",
            strokeMiterlimit: 10,
          }}
        />
        <path
          d="M449.35 1455.46c32.54 20.08 24.22 133.25-40.3 188.39-9.28 7.93-39.4 32.9-82.87 32.42-40.24-.45-67.97-22.43-80.61-32.75-61.04-49.84-86.82-147.66-56.13-175.47 6.16-5.58 17.72-11.18 41.29-7.56 13.05-39.1 46.46-66.79 85.02-70.53 43.12-4.18 84.92 22.35 102.02 65.49 15.53-5.43 25.25-3.91 31.58 0Z"
          className="cls-6cn11"
        />
        <circle cx={256.7} cy={1576.73} r={16.71} className="cls-6cn1" />
        <circle cx={327.23} cy={1529.75} r={16.71} className="cls-6cn1" />
        <circle cx={392.72} cy={1576.73} r={16.71} className="cls-6cn1" />
        <path
          d="M256.7 1576.73c5.24 16.31 15.02 39.76 33.8 63.44a200.033 200.033 0 0 0 33.93 33.6M392.16 1576.73c-5.24 16.31-15.02 39.76-33.8 63.44a200.033 200.033 0 0 1-33.93 33.6c.93-48 1.87-96.01 2.8-144.01M192.05 1504.98c.69-2.42 4.09-13.46 15.11-19.52 10.56-5.81 24-4.8 34.64 2.52 5.9-48.79 49.73-81.98 92.57-76.2 36.02 4.86 66.1 36.56 69.9 76.83 12.48-10.51 29.24-11.69 40.3-3.78 10.25 7.33 11.73 19.69 11.97 22.04"
          className="cls-6cn2"
        />
        <path
          d="M422.98 1857.67c25.79-15.83 19.2-105.04-31.94-148.51-7.36-6.25-31.23-25.93-65.68-25.56-31.89.35-53.87 17.68-63.89 25.81-48.38 39.29-68.81 116.4-44.49 138.32 4.88 4.4 14.04 8.81 32.73 5.96 10.34 30.82 36.82 52.65 67.38 55.6 34.17 3.3 67.31-17.61 80.86-51.63 12.31 4.28 20.01 3.08 25.03 0Z"
          className="cls-6cn11"
        />
        <ellipse
          cx={270.29}
          cy={1762.07}
          className="cls-6cn1"
          rx={13.24}
          ry={13.17}
        />
        <ellipse
          cx={326.19}
          cy={1799.1}
          className="cls-6cn1"
          rx={13.24}
          ry={13.17}
        />
        <ellipse
          cx={378.09}
          cy={1762.07}
          className="cls-6cn1"
          rx={13.24}
          ry={13.17}
        />
        <path
          d="M270.29 1762.07c4.15-12.86 11.91-31.34 26.79-50.01a157.712 157.712 0 0 1 26.9-26.48"
          className="cls-6cn5"
        />
        <path
          d="M377.65 1762.07c-4.15-12.86-11.91-31.34-26.79-50.01a157.712 157.712 0 0 0-26.9-26.48l2.22 113.52M219.05 1818.63c.54 1.91 3.24 10.61 11.98 15.39 8.37 4.58 19.02 3.78 27.45-1.99 4.68 38.46 39.41 64.62 73.37 60.07 28.55-3.83 52.38-28.82 55.4-60.56 9.89 8.29 23.18 9.21 31.94 2.98 8.12-5.78 9.29-15.52 9.48-17.37"
          className="cls-6cn5"
        />
        <path
          d="M372.14 1685.8c12.41-4.87 30.49-13.33 49.12-28.01 47.11-37.11 53.83-79.28 84.37-80.96 13.22-.72 28.08 6.3 35.93 18.3 10.69 16.34 4.26 35.59 3.23 38.5 28.44.55 53.68 17.81 63.73 43.45 10.22 26.11 3.09 56.82-16.38 73.77-18.15 15.81-41.34 14.73-52.18 14.22-31.27-1.46-47.89-16.73-89.08-40.41-17.62-10.13-44.19-24.36-78.75-38.86Z"
          className="cls-6cn11"
        />
        <circle cx={524.47} cy={1691.63} r={16.71} className="cls-6cn1" />
        <path
          d="M392.94 1684.49c26.62-2.64 58.53-3.21 94.06 1.52a405 405 0 0 1 37.41 6.8"
          className="cls-6cn2"
        />
        <circle cx={497.06} cy={1642.54} r={7.66} className="cls-6cn1" />
        <path
          d="M398.1 1684.01c19.24-.95 50.82-5.59 80.81-26.45 6.97-4.85 12.99-9.97 18.16-15.02"
          className="cls-6cn2"
        />
        <circle cx={499.86} cy={1733.49} r={7.66} className="cls-6cn1" />
        <path
          d="M400.48 1683.8c19.55 1.98 52.9 8.55 82.59 33.17 6.53 5.41 12.08 11.03 16.79 16.53"
          className="cls-6cn2"
        />
        <path
          d="M276.73 1685.8c-12.41-4.87-30.49-13.33-49.12-28.01-47.11-37.11-53.83-79.28-84.37-80.96-13.22-.72-28.08 6.3-35.93 18.3-10.69 16.34-4.26 35.59-3.23 38.5-28.44.55-53.68 17.81-63.73 43.45-10.22 26.11-3.09 56.82 16.38 73.77 18.15 15.81 41.34 14.73 52.18 14.22 31.27-1.46 47.89-16.73 89.08-40.41 17.62-10.13 44.19-24.36 78.75-38.86Z"
          className="cls-6cn11"
        />
        <circle cx={124.39} cy={1691.63} r={16.71} className="cls-6cn1" />
        <path
          d="M255.92 1684.49c-26.62-2.64-58.53-3.21-94.06 1.52a405 405 0 0 0-37.41 6.8"
          className="cls-6cn2"
        />
        <circle cx={151.8} cy={1642.54} r={7.66} className="cls-6cn1" />
        <path
          d="M250.77 1684.01c-19.24-.95-50.82-5.59-80.81-26.45-6.97-4.85-12.99-9.97-18.16-15.02"
          className="cls-6cn2"
        />
        <circle cx={149.01} cy={1733.49} r={7.66} className="cls-6cn1" />
        <path
          d="M248.39 1683.8c-19.55 1.98-52.9 8.55-82.59 33.17a138.033 138.033 0 0 0-16.79 16.53"
          className="cls-6cn2"
        />
        <path
          d="M1790.49 189.04c25.56 15.78 19.03 104.69-31.66 148.01-7.29 6.23-30.95 25.85-65.11 25.47-31.61-.35-53.4-17.62-63.33-25.73-47.96-39.16-68.21-116.01-44.1-137.86 4.84-4.38 13.92-8.78 32.44-5.94 10.25-30.72 36.5-52.48 66.79-55.41 33.87-3.28 66.72 17.56 80.15 51.46 12.2-4.27 19.84-3.07 24.81 0Z"
          className="cls-6cn11"
        />
        <circle cx={1639.13} cy={284.31} r={13.13} className="cls-6cn1" />
        <circle cx={1694.54} cy={247.41} r={13.13} className="cls-6cn1" />
        <circle cx={1746} cy={284.31} r={13.13} className="cls-6cn1" />
        <path
          d="M1639.13 284.31c4.12 12.81 11.8 31.23 26.55 49.84a157.25 157.25 0 0 0 26.66 26.4M1745.56 284.31c-4.12 12.81-11.8 31.23-26.55 49.84a157.25 157.25 0 0 1-26.66 26.4c.73-37.71 1.47-75.43 2.2-113.14M1588.33 227.94c.54-1.91 3.21-10.57 11.87-15.34 8.3-4.57 18.86-3.77 27.21 1.98 4.64-38.33 39.07-64.41 72.73-59.87 28.3 3.82 51.93 28.72 54.92 60.36 9.81-8.26 22.98-9.18 31.66-2.97 8.05 5.76 9.21 15.47 9.4 17.32"
          className="cls-6cn10"
        />
        <path
          d="M1769.76 505.03c20.26-12.44 15.08-82.53-25.1-116.68-5.78-4.91-24.53-20.38-51.6-20.08-25.05.28-42.32 13.89-50.19 20.28-38.01 30.87-54.06 91.45-34.95 108.67 3.83 3.46 11.03 6.92 25.71 4.68 8.12 24.21 28.93 41.37 52.94 43.68 26.85 2.59 52.88-13.84 63.53-40.56 9.67 3.36 15.72 2.42 19.66 0Z"
          className="cls-6cn11"
        />
        <ellipse
          cx={1649.8}
          cy={429.93}
          className="cls-6cn1"
          rx={10.4}
          ry={10.35}
        />
        <ellipse
          cx={1693.72}
          cy={459.02}
          className="cls-6cn1"
          rx={10.4}
          ry={10.35}
        />
        <ellipse
          cx={1734.5}
          cy={429.93}
          className="cls-6cn1"
          rx={10.4}
          ry={10.35}
        />
        <path
          d="M1649.8 429.93c3.26-10.1 9.36-24.62 21.04-39.29 7.24-9.09 14.76-15.88 21.13-20.81M1734.15 429.93c-3.26-10.1-9.36-24.62-21.04-39.29a124.024 124.024 0 0 0-21.13-20.81l1.74 89.19M1609.55 474.36c.43 1.5 2.55 8.33 9.41 12.09 6.58 3.6 14.94 2.97 21.57-1.56 3.68 30.21 30.97 50.77 57.64 47.19 22.43-3.01 41.16-22.64 43.53-47.58 7.77 6.51 18.21 7.24 25.1 2.34 6.38-4.54 7.3-12.19 7.45-13.65"
          className="cls-6cn3"
        />
        <path
          d="M1729.82 370.01c9.75-3.83 23.95-10.48 38.59-22.01 37.01-29.16 42.29-62.29 66.29-63.6 10.39-.57 22.06 4.95 28.23 14.38 8.4 12.84 3.34 27.96 2.54 30.25 22.35.44 42.18 13.99 50.07 34.14 8.03 20.51 2.43 44.64-12.87 57.96-14.26 12.42-32.48 11.57-41 11.17-24.56-1.14-37.63-13.15-69.99-31.75-13.84-7.96-34.72-19.14-61.87-30.53Z"
          className="cls-6cn11"
        />
        <circle cx={1849.51} cy={374.59} r={13.13} className="cls-6cn1" />
        <path
          d="M1746.17 368.98c20.92-2.07 45.98-2.52 73.9 1.2 10.46 1.39 20.27 3.24 29.39 5.34"
          className="cls-6cn10"
        />
        <circle cx={1827.97} cy={336.01} r={6.02} className="cls-6cn1" />
        <path
          d="M1750.22 368.6c15.12-.74 39.93-4.39 63.49-20.78 5.48-3.81 10.2-7.83 14.26-11.8"
          className="cls-6cn10"
        />
        <circle cx={1830.16} cy={407.48} r={6.02} className="cls-6cn1" />
        <path
          d="M1752.09 368.43c15.36 1.56 41.56 6.72 64.89 26.06 5.13 4.25 9.49 8.67 13.19 12.99"
          className="cls-6cn10"
        />
        <path
          d="M1654.86 370.01c-9.75-3.83-23.95-10.48-38.59-22.01-37.01-29.16-42.29-62.29-66.29-63.6-10.39-.57-22.06 4.95-28.23 14.38-8.4 12.84-3.34 27.96-2.54 30.25-22.35.44-42.18 13.99-50.07 34.14-8.03 20.51-2.43 44.64 12.87 57.96 14.26 12.42 32.48 11.57 41 11.17 24.56-1.14 37.63-13.15 69.99-31.75 13.84-7.96 34.72-19.14 61.87-30.53Z"
          className="cls-6cn11"
        />
        <circle cx={1535.18} cy={374.59} r={13.13} className="cls-6cn1" />
        <path
          d="M1638.52 368.98c-20.92-2.07-45.98-2.52-73.9 1.2a316.944 316.944 0 0 0-29.39 5.34"
          className="cls-6cn10"
        />
        <circle cx={1556.71} cy={336.01} r={6.02} className="cls-6cn1" />
        <path
          d="M1634.47 368.6c-15.12-.74-39.93-4.39-63.49-20.78a111.04 111.04 0 0 1-14.26-11.8"
          className="cls-6cn10"
        />
        <circle cx={1554.52} cy={407.48} r={6.02} className="cls-6cn1" />
        <path
          d="M1632.6 368.43c-15.36 1.56-41.56 6.72-64.89 26.06a108.49 108.49 0 0 0-13.19 12.99"
          className="cls-6cn10"
        />
        <path
          d="M1810.97 619.67c13.51 8.34 10.05 55.31-16.73 78.19-3.85 3.29-16.35 13.66-34.39 13.46-16.7-.18-28.21-9.31-33.46-13.59-25.34-20.69-36.04-61.29-23.3-72.83 2.56-2.32 7.36-4.64 17.14-3.14 5.41-16.23 19.28-27.72 35.29-29.27 17.9-1.74 35.25 9.27 42.34 27.18 6.44-2.25 10.48-1.62 13.11 0Z"
          className="cls-6cn11"
        />
        <circle cx={1731.01} cy={670.01} r={6.94} className="cls-6cn1" />
        <circle cx={1760.29} cy={650.51} r={6.94} className="cls-6cn1" />
        <circle cx={1787.47} cy={670.01} r={6.94} className="cls-6cn1" />
        <path
          d="M1731.01 670.01c2.18 6.77 6.24 16.5 14.03 26.33a83.098 83.098 0 0 0 14.08 13.94M1787.24 670.01c-2.18 6.77-6.24 16.5-14.03 26.33a83.098 83.098 0 0 1-14.08 13.94c.39-19.92.77-39.85 1.16-59.77M1704.18 640.23c.28-1.01 1.7-5.59 6.27-8.1 4.38-2.41 9.96-1.99 14.38 1.05 2.45-20.25 20.64-34.03 38.42-31.63 14.95 2.02 27.43 15.17 29.01 31.89 5.18-4.36 12.14-4.85 16.73-1.57 4.25 3.04 4.87 8.17 4.97 9.15"
          className="cls-6cn8"
        />
        <path
          d="M1800.02 786.61c10.7-6.57 7.97-43.6-13.26-61.64-3.05-2.6-12.96-10.76-27.26-10.61-13.24.15-22.36 7.34-26.52 10.71-20.08 16.31-28.56 48.31-18.47 57.41 2.03 1.83 5.83 3.66 13.58 2.47 4.29 12.79 15.28 21.85 27.97 23.08 14.18 1.37 27.94-7.31 33.56-21.43 5.11 1.78 8.31 1.28 10.39 0Z"
          className="cls-6cn11"
        />
        <ellipse
          cx={1736.65}
          cy={746.94}
          className="cls-6cn1"
          rx={5.5}
          ry={5.47}
        />
        <ellipse
          cx={1759.85}
          cy={762.31}
          className="cls-6cn1"
          rx={5.5}
          ry={5.47}
        />
        <ellipse
          cx={1781.4}
          cy={746.94}
          className="cls-6cn1"
          rx={5.5}
          ry={5.47}
        />
        <path
          d="M1736.65 746.94a65.521 65.521 0 0 1 11.12-20.76c3.83-4.8 7.8-8.39 11.16-10.99M1781.21 746.94a65.521 65.521 0 0 0-11.12-20.76c-3.83-4.8-7.8-8.39-11.16-10.99.31 15.71.61 31.41.92 47.12M1715.38 770.41c.23.79 1.35 4.4 4.97 6.39 3.47 1.9 7.89 1.57 11.39-.82 1.94 15.96 16.36 26.82 30.45 24.93 11.85-1.59 21.74-11.96 22.99-25.14 4.11 3.44 9.62 3.82 13.26 1.24 3.37-2.4 3.86-6.44 3.94-7.21"
          className="cls-6cn6"
        />
        <path
          d="M1778.93 715.28c5.15-2.02 12.65-5.53 20.39-11.63 19.55-15.4 22.34-32.91 35.02-33.6 5.49-.3 11.66 2.61 14.91 7.59 4.44 6.78 1.77 14.77 1.34 15.98 11.81.23 22.28 7.39 26.45 18.04 4.24 10.84 1.28 23.58-6.8 30.62-7.53 6.56-17.16 6.11-21.66 5.9-12.98-.6-19.88-6.95-36.97-16.77-7.31-4.2-18.34-10.11-32.69-16.13Z"
          className="cls-6cn11"
        />
        <circle cx={1842.15} cy={717.7} r={6.94} className="cls-6cn1" />
        <path
          d="M1787.56 714.73c11.05-1.1 24.29-1.33 39.04.63 5.53.74 10.71 1.71 15.53 2.82"
          className="cls-6cn8"
        />
        <circle cx={1830.78} cy={697.32} r={3.18} className="cls-6cn1" />
        <path
          d="M1789.7 714.54c7.99-.39 21.09-2.32 33.54-10.98a59.83 59.83 0 0 0 7.54-6.23"
          className="cls-6cn8"
        />
        <circle cx={1831.93} cy={735.07} r={3.18} className="cls-6cn1" />
        <path
          d="M1790.69 714.45c8.12.82 21.96 3.55 34.28 13.77 2.71 2.25 5.01 4.58 6.97 6.86"
          className="cls-6cn8"
        />
        <path
          d="M1739.32 715.28c-5.15-2.02-12.65-5.53-20.39-11.63-19.55-15.4-22.34-32.91-35.02-33.6-5.49-.3-11.66 2.61-14.91 7.59-4.44 6.78-1.77 14.77-1.34 15.98-11.81.23-22.28 7.39-26.45 18.04-4.24 10.84-1.28 23.58 6.8 30.62 7.53 6.56 17.16 6.11 21.66 5.9 12.98-.6 19.88-6.95 36.97-16.77 7.31-4.2 18.34-10.11 32.69-16.13Z"
          className="cls-6cn11"
        />
        <circle cx={1676.1} cy={717.7} r={6.94} className="cls-6cn1" />
        <path
          d="M1730.69 714.73c-11.05-1.1-24.29-1.33-39.04.63-5.53.74-10.71 1.71-15.53 2.82"
          className="cls-6cn8"
        />
        <circle cx={1687.47} cy={697.32} r={3.18} className="cls-6cn1" />
        <path
          d="M1728.55 714.54c-7.99-.39-21.09-2.32-33.54-10.98a59.83 59.83 0 0 1-7.54-6.23"
          className="cls-6cn8"
        />
        <circle cx={1686.31} cy={735.07} r={3.18} className="cls-6cn1" />
        <path
          d="M1727.56 714.45c-8.12.82-21.96 3.55-34.28 13.77a58.244 58.244 0 0 0-6.97 6.86"
          className="cls-6cn8"
        />
        <path
          d="M291.84 1201.03c13.51 8.34 10.05 55.31-16.73 78.19-3.85 3.29-16.35 13.66-34.39 13.46-16.7-.18-28.21-9.31-33.46-13.59-25.34-20.69-36.04-61.29-23.3-72.83 2.56-2.32 7.36-4.64 17.14-3.14 5.41-16.23 19.28-27.72 35.29-29.27 17.9-1.74 35.25 9.27 42.34 27.18 6.44-2.25 10.48-1.62 13.11 0Z"
          className="cls-6cn11"
        />
        <circle cx={211.88} cy={1251.36} r={6.94} className="cls-6cn1" />
        <circle cx={241.15} cy={1231.86} r={6.94} className="cls-6cn1" />
        <circle cx={268.34} cy={1251.36} r={6.94} className="cls-6cn1" />
        <path
          d="M211.88 1251.36c2.18 6.77 6.24 16.5 14.03 26.33a83.098 83.098 0 0 0 14.08 13.94M268.1 1251.36c-2.18 6.77-6.24 16.5-14.03 26.33a83.098 83.098 0 0 1-14.08 13.94c.39-19.92.77-39.85 1.16-59.77M185.05 1221.58c.28-1.01 1.7-5.59 6.27-8.1 4.38-2.41 9.96-1.99 14.38 1.05 2.45-20.25 20.64-34.03 38.42-31.63 14.95 2.02 27.43 15.17 29.01 31.89 5.18-4.36 12.14-4.85 16.73-1.57 4.25 3.04 4.87 8.17 4.97 9.15"
          className="cls-6cn8"
        />
        <path
          d="M280.89 1367.97c10.7-6.57 7.97-43.6-13.26-61.64-3.05-2.6-12.96-10.76-27.26-10.61-13.24.15-22.36 7.34-26.52 10.71-20.08 16.31-28.56 48.31-18.47 57.41 2.03 1.83 5.83 3.66 13.58 2.47 4.29 12.79 15.28 21.85 27.97 23.08 14.18 1.37 27.94-7.31 33.56-21.43 5.11 1.78 8.31 1.28 10.39 0Z"
          className="cls-6cn11"
        />
        <ellipse
          cx={217.52}
          cy={1328.29}
          className="cls-6cn1"
          rx={5.5}
          ry={5.47}
        />
        <ellipse
          cx={240.72}
          cy={1343.66}
          className="cls-6cn1"
          rx={5.5}
          ry={5.47}
        />
        <ellipse
          cx={262.26}
          cy={1328.29}
          className="cls-6cn1"
          rx={5.5}
          ry={5.47}
        />
        <path
          d="M217.52 1328.29a65.521 65.521 0 0 1 11.12-20.76c3.83-4.8 7.8-8.39 11.16-10.99"
          className="cls-6cn6"
        />
        <path
          d="M262.08 1328.29a65.521 65.521 0 0 0-11.12-20.76c-3.83-4.8-7.8-8.39-11.16-10.99.31 15.71.61 31.41.92 47.12M196.25 1351.76c.23.79 1.35 4.4 4.97 6.39 3.47 1.9 7.89 1.57 11.39-.82 1.94 15.96 16.36 26.82 30.45 24.93 11.85-1.59 21.74-11.96 22.99-25.14 4.11 3.44 9.62 3.82 13.26 1.24 3.37-2.4 3.86-6.44 3.94-7.21"
          className="cls-6cn6"
        />
        <path
          d="M259.79 1296.63c5.15-2.02 12.65-5.53 20.39-11.63 19.55-15.4 22.34-32.91 35.02-33.6 5.49-.3 11.66 2.61 14.91 7.59 4.44 6.78 1.77 14.77 1.34 15.98 11.81.23 22.28 7.39 26.45 18.04 4.24 10.84 1.28 23.58-6.8 30.62-7.53 6.56-17.16 6.11-21.66 5.9-12.98-.6-19.88-6.95-36.97-16.77-7.31-4.2-18.34-10.11-32.69-16.13Z"
          className="cls-6cn11"
        />
        <circle cx={323.02} cy={1299.05} r={6.94} className="cls-6cn1" />
        <path
          d="M268.43 1296.09c11.05-1.1 24.29-1.33 39.04.63 5.53.74 10.71 1.71 15.53 2.82"
          className="cls-6cn8"
        />
        <circle cx={311.64} cy={1278.67} r={3.18} className="cls-6cn1" />
        <path
          d="M270.57 1295.89c7.99-.39 21.09-2.32 33.54-10.98a59.83 59.83 0 0 0 7.54-6.23"
          className="cls-6cn8"
        />
        <circle cx={312.8} cy={1316.43} r={3.18} className="cls-6cn1" />
        <path
          d="M271.55 1295.8c8.12.82 21.96 3.55 34.28 13.77 2.71 2.25 5.01 4.58 6.97 6.86"
          className="cls-6cn8"
        />
        <path
          d="M220.19 1296.63c-5.15-2.02-12.65-5.53-20.39-11.63-19.55-15.4-22.34-32.91-35.02-33.6-5.49-.3-11.66 2.61-14.91 7.59-4.44 6.78-1.77 14.77-1.34 15.98-11.81.23-22.28 7.39-26.45 18.04-4.24 10.84-1.28 23.58 6.8 30.62 7.53 6.56 17.16 6.11 21.66 5.9 12.98-.6 19.88-6.95 36.97-16.77 7.31-4.2 18.34-10.11 32.69-16.13Z"
          className="cls-6cn11"
        />
        <circle cx={156.96} cy={1299.05} r={6.94} className="cls-6cn1" />
        <path
          d="M211.56 1296.09c-11.05-1.1-24.29-1.33-39.04.63-5.53.74-10.71 1.71-15.53 2.82"
          className="cls-6cn8"
        />
        <circle cx={168.34} cy={1278.67} r={3.18} className="cls-6cn1" />
        <path
          d="M209.42 1295.89c-7.99-.39-21.09-2.32-33.54-10.98a59.83 59.83 0 0 1-7.54-6.23"
          className="cls-6cn8"
        />
        <circle cx={167.18} cy={1316.43} r={3.18} className="cls-6cn1" />
        <path
          d="M208.43 1295.8c-8.12.82-21.96 3.55-34.28 13.77a58.244 58.244 0 0 0-6.97 6.86"
          className="cls-6cn8"
        />
        <path
          d="M593.32 1820.67c9.86 6.09 7.34 40.4-12.22 57.11-2.81 2.41-11.94 9.97-25.12 9.83-12.2-.14-20.61-6.8-24.44-9.93-18.51-15.11-26.32-44.77-17.02-53.19 1.87-1.69 5.37-3.39 12.52-2.29 3.95-11.85 14.08-20.25 25.77-21.38 13.07-1.27 25.75 6.77 30.93 19.85 4.71-1.65 7.65-1.18 9.57 0Z"
          className="cls-6cn11"
        />
        <circle cx={534.92} cy={1857.43} r={5.07} className="cls-6cn1" />
        <circle cx={556.3} cy={1843.19} r={5.07} className="cls-6cn1" />
        <circle cx={576.15} cy={1857.43} r={5.07} className="cls-6cn1" />
        <path
          d="M534.92 1857.43c1.59 4.94 4.55 12.05 10.25 19.23 3.53 4.45 7.18 7.77 10.29 10.19"
          className="cls-6cn4"
        />
        <path
          d="M575.98 1857.43c-1.59 4.94-4.55 12.05-10.25 19.23a60.684 60.684 0 0 1-10.29 10.19c.28-14.55.57-29.1.85-43.66M515.32 1835.68c.21-.74 1.24-4.08 4.58-5.92 3.2-1.76 7.28-1.45 10.5.76 1.79-14.79 15.08-24.85 28.06-23.1 10.92 1.47 20.04 11.08 21.19 23.29 3.78-3.19 8.87-3.54 12.22-1.15 3.11 2.22 3.56 5.97 3.63 6.68"
          className="cls-6cn4"
        />
        <path
          d="M585.32 1942.6c7.82-4.8 5.82-31.84-9.68-45.02-2.23-1.9-9.47-7.86-19.91-7.75-9.67.11-16.33 5.36-19.37 7.83-14.67 11.91-20.86 35.29-13.49 41.93 1.48 1.33 4.26 2.67 9.92 1.81 3.13 9.34 11.16 15.96 20.43 16.86 10.36 1 20.4-5.34 24.51-15.65 3.73 1.3 6.07.93 7.59 0Z"
          className="cls-6cn11"
        />
        <ellipse
          cx={539.04}
          cy={1913.62}
          className="cls-6cn1"
          rx={4.01}
          ry={3.99}
        />
        <ellipse
          cx={555.98}
          cy={1924.84}
          className="cls-6cn1"
          rx={4.01}
          ry={3.99}
        />
        <ellipse
          cx={571.72}
          cy={1913.62}
          className="cls-6cn1"
          rx={4.01}
          ry={3.99}
        />
        <path
          d="M539.04 1913.62c1.26-3.9 3.61-9.5 8.12-15.16 2.79-3.51 5.69-6.13 8.15-8.03M571.58 1913.62c-1.26-3.9-3.61-9.5-8.12-15.16a47.468 47.468 0 0 0-8.15-8.03l.67 34.41M523.5 1930.76c.16.58.98 3.22 3.63 4.67 2.54 1.39 5.77 1.15 8.32-.6 1.42 11.66 11.95 19.59 22.24 18.21 8.65-1.16 15.88-8.74 16.8-18.36 3 2.51 7.03 2.79 9.68.9 2.46-1.75 2.82-4.71 2.87-5.27"
          className="cls-6cn9"
        />
        <path
          d="M569.91 1890.5c3.76-1.48 9.24-4.04 14.89-8.49 14.28-11.25 16.32-24.04 25.58-24.54 4.01-.22 8.51 1.91 10.89 5.55 3.24 4.95 1.29 10.79.98 11.67 8.62.17 16.28 5.4 19.32 13.17 3.1 7.91.94 17.22-4.96 22.37-5.5 4.79-12.53 4.46-15.82 4.31-9.48-.44-14.52-5.07-27.01-12.25-5.34-3.07-13.4-7.39-23.87-11.78Z"
          className="cls-6cn11"
        />
        <circle cx={616.09} cy={1892.26} r={5.07} className="cls-6cn1" />
        <path
          d="M576.22 1890.1c8.07-.8 17.74-.97 28.51.46 4.04.54 7.82 1.25 11.34 2.06"
          className="cls-6cn4"
        />
        <circle cx={607.79} cy={1877.38} r={2.32} className="cls-6cn1" />
        <path
          d="M577.78 1889.95c5.83-.29 15.41-1.7 24.5-8.02 2.11-1.47 3.94-3.02 5.5-4.55"
          className="cls-6cn4"
        />
        <circle cx={608.63} cy={1904.95} r={2.32} className="cls-6cn1" />
        <path
          d="M578.5 1889.89c5.93.6 16.04 2.59 25.04 10.05 1.98 1.64 3.66 3.34 5.09 5.01"
          className="cls-6cn4"
        />
        <path
          d="M540.99 1890.5c-3.76-1.48-9.24-4.04-14.89-8.49-14.28-11.25-16.32-24.04-25.58-24.54-4.01-.22-8.51 1.91-10.89 5.55-3.24 4.95-1.29 10.79-.98 11.67-8.62.17-16.28 5.4-19.32 13.17-3.1 7.91-.94 17.22 4.96 22.37 5.5 4.79 12.53 4.46 15.82 4.31 9.48-.44 14.52-5.07 27.01-12.25 5.34-3.07 13.4-7.39 23.87-11.78Z"
          className="cls-6cn11"
        />
        <circle cx={494.81} cy={1892.26} r={5.07} className="cls-6cn1" />
        <path
          d="M534.68 1890.1c-8.07-.8-17.74-.97-28.51.46-4.04.54-7.82 1.25-11.34 2.06"
          className="cls-6cn4"
        />
        <circle cx={503.12} cy={1877.38} r={2.32} className="cls-6cn1" />
        <path
          d="M533.12 1889.95c-5.83-.29-15.41-1.7-24.5-8.02a42.806 42.806 0 0 1-5.5-4.55"
          className="cls-6cn4"
        />
        <circle cx={502.27} cy={1904.95} r={2.32} className="cls-6cn1" />
        <path
          d="M532.4 1889.89c-5.93.6-16.04 2.59-25.04 10.05a41.769 41.769 0 0 0-5.09 5.01"
          className="cls-6cn4"
        />
        <path
          d="M1490.96 101.86c9.86 6.09 7.34 40.4-12.22 57.11-2.81 2.41-11.94 9.97-25.12 9.83-12.2-.14-20.61-6.8-24.44-9.93-18.51-15.11-26.32-44.77-17.02-53.19 1.87-1.69 5.37-3.39 12.52-2.29 3.95-11.85 14.08-20.25 25.77-21.38 13.07-1.27 25.75 6.77 30.93 19.85 4.71-1.65 7.65-1.18 9.57 0Z"
          className="cls-6cn11"
        />
        <circle cx={1432.55} cy={138.62} r={5.07} className="cls-6cn1" />
        <circle cx={1453.94} cy={124.38} r={5.07} className="cls-6cn1" />
        <circle cx={1473.79} cy={138.62} r={5.07} className="cls-6cn1" />
        <path
          d="M1432.55 138.62c1.59 4.94 4.55 12.05 10.25 19.23 3.53 4.45 7.18 7.77 10.29 10.19"
          className="cls-6cn4"
        />
        <path
          d="M1473.62 138.62c-1.59 4.94-4.55 12.05-10.25 19.23a60.684 60.684 0 0 1-10.29 10.19c.28-14.55.57-29.1.85-43.66M1412.95 116.87c.21-.74 1.24-4.08 4.58-5.92 3.2-1.76 7.28-1.45 10.5.76 1.79-14.79 15.08-24.85 28.06-23.1 10.92 1.47 20.04 11.08 21.19 23.29 3.78-3.19 8.87-3.54 12.22-1.15 3.11 2.22 3.56 5.97 3.63 6.68"
          className="cls-6cn4"
        />
        <path
          d="M1482.96 223.79c7.82-4.8 5.82-31.84-9.68-45.02-2.23-1.9-9.47-7.86-19.91-7.75-9.67.11-16.33 5.36-19.37 7.83-14.67 11.91-20.86 35.29-13.49 41.93 1.48 1.33 4.26 2.67 9.92 1.81 3.13 9.34 11.16 15.96 20.43 16.86 10.36 1 20.4-5.34 24.51-15.65 3.73 1.3 6.07.93 7.59 0Z"
          className="cls-6cn11"
        />
        <ellipse
          cx={1436.67}
          cy={194.81}
          className="cls-6cn1"
          rx={4.01}
          ry={3.99}
        />
        <ellipse
          cx={1453.62}
          cy={206.04}
          className="cls-6cn1"
          rx={4.01}
          ry={3.99}
        />
        <ellipse
          cx={1469.36}
          cy={194.81}
          className="cls-6cn1"
          rx={4.01}
          ry={3.99}
        />
        <path
          d="M1436.67 194.81c1.26-3.9 3.61-9.5 8.12-15.16 2.79-3.51 5.69-6.13 8.15-8.03M1469.22 194.81c-1.26-3.9-3.61-9.5-8.12-15.16a47.468 47.468 0 0 0-8.15-8.03c.22 11.47.45 22.94.67 34.41M1421.14 211.96c.16.58.98 3.22 3.63 4.67 2.54 1.39 5.77 1.15 8.32-.6 1.42 11.66 11.95 19.59 22.24 18.21 8.65-1.16 15.88-8.74 16.8-18.36 3 2.51 7.03 2.79 9.68.9 2.46-1.75 2.82-4.71 2.87-5.27"
          className="cls-6cn9"
        />
        <path
          d="M1467.55 171.69c3.76-1.48 9.24-4.04 14.89-8.49 14.28-11.25 16.32-24.04 25.58-24.54 4.01-.22 8.51 1.91 10.89 5.55 3.24 4.95 1.29 10.79.98 11.67 8.62.17 16.28 5.4 19.32 13.17 3.1 7.91.94 17.22-4.96 22.37-5.5 4.79-12.53 4.46-15.82 4.31-9.48-.44-14.52-5.07-27.01-12.25-5.34-3.07-13.4-7.39-23.87-11.78Z"
          className="cls-6cn11"
        />
        <circle cx={1513.73} cy={173.46} r={5.07} className="cls-6cn1" />
        <path
          d="M1473.86 171.29c8.07-.8 17.74-.97 28.51.46 4.04.54 7.82 1.25 11.34 2.06"
          className="cls-6cn4"
        />
        <circle cx={1505.42} cy={158.57} r={2.32} className="cls-6cn1" />
        <path
          d="M1475.42 171.15c5.83-.29 15.41-1.7 24.5-8.02 2.11-1.47 3.94-3.02 5.5-4.55"
          className="cls-6cn4"
        />
        <circle cx={1506.27} cy={186.15} r={2.32} className="cls-6cn1" />
        <path
          d="M1476.14 171.08c5.93.6 16.04 2.59 25.04 10.05 1.98 1.64 3.66 3.34 5.09 5.01"
          className="cls-6cn4"
        />
        <path
          d="M1438.62 171.69c-3.76-1.48-9.24-4.04-14.89-8.49-14.28-11.25-16.32-24.04-25.58-24.54-4.01-.22-8.51 1.91-10.89 5.55-3.24 4.95-1.29 10.79-.98 11.67-8.62.17-16.28 5.4-19.32 13.17-3.1 7.91-.94 17.22 4.96 22.37 5.5 4.79 12.53 4.46 15.82 4.31 9.48-.44 14.52-5.07 27.01-12.25 5.34-3.07 13.4-7.39 23.87-11.78Z"
          className="cls-6cn11"
        />
        <circle cx={1392.44} cy={173.46} r={5.07} className="cls-6cn1" />
        <path
          d="M1432.32 171.29c-8.07-.8-17.74-.97-28.51.46-4.04.54-7.82 1.25-11.34 2.06"
          className="cls-6cn4"
        />
        <circle cx={1400.75} cy={158.57} r={2.32} className="cls-6cn1" />
        <path
          d="M1430.76 171.15c-5.83-.29-15.41-1.7-24.5-8.02a42.806 42.806 0 0 1-5.5-4.55"
          className="cls-6cn4"
        />
        <circle cx={1399.91} cy={186.15} r={2.32} className="cls-6cn1" />
        <path
          d="M1430.03 171.08c-5.93.6-16.04 2.59-25.04 10.05a41.769 41.769 0 0 0-5.09 5.01"
          className="cls-6cn4"
        />
        {children}
      </g>
    </svg>
  );
}
